import React, { useEffect, useRef } from 'react';
import useResponsiblePersons from '@hooks/responsible-persons/responsible-persons';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { LovDTO } from '@api/ringil-api.v2';
import { deferStampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  responsiblePerson: LovDTO;
  onChange: (responsiblePerson: LovDTO) => void;
  style?: any;
  showClearButton?: boolean;
  disabled?: boolean;
  placeholder?: string;
  dataTestId?: string;
}

const InputResponsiblePerson: React.FC<ComponentProps> = ({ responsiblePerson, onChange, style, showClearButton = false, disabled = false, placeholder, dataTestId }) => {
  const responsiblePersons = useResponsiblePersons();
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    return deferStampDataTestIdOnDescendantRef(wrapperRef, '.p-dropdown', dataTestId);
  }, [dataTestId, responsiblePersons]);

  return (
    <div ref={wrapperRef}>
      <Dropdown
        className="w-full"
        value={responsiblePerson}
        options={responsiblePersons}
        onChange={e => onChange(e.target.value)}
        optionLabel="name"
        dataKey={'id'}
        style={style}
        showClear={showClearButton}
        disabled={disabled}
        placeholder={placeholder}
        filter={true}
        panelClassName={dataTestId}
        itemTemplate={(option: LovDTO) => (
          <div data-testid={dataTestId ? `${dataTestId}-${toTestIdSlug(option.name)}` : undefined}>
            {option.active ? <span>{option.name}</span> : <span style={{ textDecoration: 'line-through', color: 'gray' }}>{option.name}</span>}
          </div>
        )}
      />
    </div>
  );
};

export default InputResponsiblePerson;
